export enum NotePublicationOwnerType {
  CLINICAL_TEAM = 'CLINICAL_TEAM',
  AI = 'AI',
  MEMBER = 'MEMBER'
}

export interface NotePublication {
  id: number
  text: string
  markdown: boolean
  change_owner_id?: number
  change_owner_type?: NotePublicationOwnerType
  change_owner_name?: string
  _created: Date
}

export interface NotesStore {
  getUserNotes: (userId: number) => Promise<NotePublication[]>
  postUserNote: (
    userId: number,
    text: string
  ) => Promise<{ success: boolean; note?: NotePublication }>
  deleteUserNote: (userId: number, noteId: number) => Promise<boolean>
}
